module.exports = __webpack_public_path__ + "f55e9bd8fcf9ddf780751ec5fb88231c.jpg";